import accessToken from "../../helpers/accessToken";
import Mixins from "../../mixins/GlobalMixins";
import API_URL from "../../helpers/apiUrls";

const state = {
 
  createContent__Post: {
    // type:"",
    brandName: "",
    time: "",
    logo: "",
    images: [],
    heading: "",
    description: "",
    likes: 0,
    comments: 0,
    shares: 0,
    dialog: false,
    feedtype:""
  },

  createContent__Poll: {
    brandName: "",
    time: "",
    logo: "",
    heading: "",
    description: "",
    likes: 0,
    comments: 0,
    shares: 0,
    options: [],
    dialog: false,
    responseCount: 0,
    feedtype:""
  },

  createContent__Video: {
    brandName: "",
    time: "",
    logo: "",
    heading: "",
    description: "",
    likes: 0,
    comments: 0,
    shares: 0,
    video: "",
    views: "",
    dialog: false,
    responseCount: 0,
    feedtype:""

  },

  selectedForm : {
    ID : '',
    formName : 'Add Inquiry form/product',
    postID : '',
    postType : ''
  }
};

const mutations = {
  // value <=> response.data
  SET_POST_DETAILS: (state, value) => {
    // console.log("VALUEE::STORE",value)
    state.createContent__Post.brandName =value.brand? value.brand.name:accessToken.getCredentials().brandName;
    state.createContent__Post.time = value.details.published_at;
    state.createContent__Post.logo = value.brand? value.brand.logo_image.thumbnail:accessToken.getCredentials().brandLogo;
    state.createContent__Post.images = value.details.media;
    state.createContent__Post.heading = value.details.heading;
    state.createContent__Post.description = value.details.description;
    state.createContent__Post.likes = value.stats.likes;
    state.createContent__Post.comments = value.stats.comments;
    state.createContent__Post.shares = value.stats.shared;
    state.createContent__Post.id = value.details.id;
    state.createContent__Post.feedtype="post_feed"

    if (value.from === "edit")
      state.createContent__Post.createPostDialog = true;
    else state.createContent__Post.dialog = true;
  },

  SET_POLL_DETAILS: (state, value) => {
    // console.log("VALUESS:",type)
    state.createContent__Poll.brandName = value.brand? value.brand.name:accessToken.getCredentials().brandName;
    state.createContent__Poll.time = value.created_at;
    state.createContent__Poll.logo = value.brand? value.brand.logo_image.thumbnail:accessToken.getCredentials().brandLogo;
    state.createContent__Poll.heading = value.text;
    state.createContent__Poll.responseCount = value.response_count;
    state.createContent__Poll.options = value.options.map((option) => {
      return {
        text: option.text,
        count: option.option_response_count,
      };
    });
    state.createContent__Poll.likes = value.stats.likes;
    state.createContent__Poll.comments = value.stats.comments;
    state.createContent__Poll.shares = value.stats.shared;
    state.createContent__Poll.id = value.id;
    state.createContent__Poll.feedtype="poll_feed"

    state.createContent__Poll.dialog = true;
    // console.log(state.createContent__Poll);
  },

  SET_VIDEO_DETAILS: (state, value) => {
   console.log(value,"IDDDD OF POST");
    state.createContent__Video.brandName = value.brand? value.brand.name:accessToken.getCredentials().brandName;
    state.createContent__Video.time = value.created_at;
    state.createContent__Video.logo = value.brand? value.brand.logo_image.thumbnail:accessToken.getCredentials().brandLogo;
    state.createContent__Video.description = value.details.description;
    state.createContent__Video.responseCount = value.response_count;
    state.createContent__Video.video = value.details;
    state.createContent__Video.likes = value.stats.likes;
    state.createContent__Video.views=value.stats.views;
    state.createContent__Video.comments = value.stats.comments;
    state.createContent__Video.shares = value.stats.shared;
    state.createContent__Video.id = value.details.id;
    state.createContent__Video.feedtype="clip_feed"
    state.createContent__Video.dialog = true;
    console.log( state.createContent__Video.video,"video Details POST");
  },

  REMOVE_SELECTED_FORM : (state) => {
    state.selectedForm.ID = '';
    state.selectedForm.formName = 'Add Inquiry form/product';
    state.selectedForm.postID = '';
    state.selectedForm.postType = '';
  }
};

const actions = {
  getPostDetails({ commit, dispatch }, data) {
    const successHandler = (response) => {
      if (response.status === 200) {
        response.data["from"] = data.from;
       // console.log(response.data);
        dispatch("mainStore/toggleLoader", false, { root: true });
        commit("SET_POST_DETAILS", response.data);
      }
    };

    const errorHandler = (error) => {
      console.log(error);
    };

    const headers = {
      Authorization: `Bearer ${accessToken.getAccessToken()}`,
      "BRAND-ID": localStorage.getItem("Brand-ID"),
    };

    const payload = {
      post_type: data.postType,
      post_id: data.postID,
    };

    Mixins.methods.requestGET(
      API_URL.createContent__postDetails,
      payload,
      headers,
      successHandler,
      errorHandler
    );
  },

  getPollDetails({ commit, dispatch }, data) {
    const successHandler = (response) => {
      if (response.status === 200) {
        dispatch("mainStore/toggleLoader", false, { root: true });
        commit("SET_POLL_DETAILS", response.data.poll);
      }
    };

    const errorHandler = (error) => {
      console.log(error);
    };

    const headers = {
      Authorization: `Bearer ${accessToken.getAccessToken()}`,
      "BRAND-ID": localStorage.getItem("Brand-ID"),
    };

    const payload = {
      post_type: data.postType,
      post_id: data.postID,
    };

    Mixins.methods.requestGET(
      API_URL.createContent__postDetails,
      payload,
      headers,
      successHandler,
      errorHandler
    );
  },

  getVideoDetails({ commit, dispatch }, data) {
    const successHandler = (response) => {
      if (response.status === 200) {
        dispatch("mainStore/toggleLoader", false, { root: true });
        commit("SET_VIDEO_DETAILS", response.data.clips);
        console.log("res", response.data.clips.stats);
      }
    };

    const errorHandler = (error) => {
      console.log(error);
    };

    const headers = {
      Authorization: `Bearer ${accessToken.getAccessToken()}`,
      "BRAND-ID": localStorage.getItem("Brand-ID"),
    };

    const payload = {
      post_type: data.postType,
      post_id: data.postID,
    };

    Mixins.methods.requestGET(
      API_URL.createContent__postDetails,
      payload,
      headers,
      successHandler,
      errorHandler
    );
  },

  attachFormWithPost({dispatch}, data) {
    const successHandler = response => {
      if(response.status) {
        dispatch("mainStore/toggleLoader", false, { root: true });
      }
    };

    const errorHandler = (error) => {
      console.log(error);
    };

    const headers = {
      Authorization: `Bearer ${accessToken.getAccessToken()}`,
      "BRAND-ID": localStorage.getItem("Brand-ID"),
    };

    Mixins.methods.requestPOST(
      API_URL.createContent__attachForm,
      data,
      headers,
      successHandler,
      errorHandler
    );
  },
};

const getters = {
  GET_POST_DETAILS: (state) => state.createContent__Post,

  GET_POLL_DETAILS: (state) => state.createContent__Poll,

  GET_VIDEO_DETAILS: (state) => state.createContent__Video,

  GET_SELECTED_FORM : (state) => state.selectedForm
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
